import React from 'react';
import PropTypes from 'prop-types';

import SrBadge, {
  SR_BADGE_THEME_GREY,
  SR_BADGE_THEME_ORANGE,
  SR_BADGE_THEME_BLUE,
  SR_BADGE_THEME_GREEN,
} from 'client/components/SrBadge/SrBadge';

const CircleMinusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M8 12h8" />
  </svg>
);

const ClockIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const CircleCheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

const CircleXIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="m15 9-6 6" />
    <path d="m9 9 6 6" />
  </svg>
);

const CircleSlashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M5.636 5.636 18.364 18.364" />
  </svg>
);

export const STATE_TO_THEME_MAPPING = {
  paid: SR_BADGE_THEME_GREEN,
  awaiting_first_payment: SR_BADGE_THEME_BLUE,
  subscription_pending: SR_BADGE_THEME_BLUE,
  canceled: SR_BADGE_THEME_GREY,
  payment_failing: SR_BADGE_THEME_ORANGE,
  not_retrying: SR_BADGE_THEME_ORANGE,
  canceled_by_stripe: SR_BADGE_THEME_ORANGE,
  bill_manually: SR_BADGE_THEME_ORANGE,
  needs_review: SR_BADGE_THEME_ORANGE,
};

export const STATE_TO_ICON_MAPPING = {
  paid: <CircleCheckIcon />,
  awaiting_first_payment: <ClockIcon />,
  subscription_pending: <ClockIcon />,
  canceled: <CircleSlashIcon />,
  payment_failing: <CircleXIcon />,
  not_retrying: <CircleXIcon />,
  canceled_by_stripe: <CircleXIcon />,
  bill_manually: <CircleMinusIcon />,
  needs_review: <CircleMinusIcon />,
};

export const bulkBillingBadgeTheme = (state, warning) => {
  if (warning) {
    return SR_BADGE_THEME_ORANGE;
  }
  const theme = STATE_TO_THEME_MAPPING[state];
  return !theme || theme === SR_BADGE_THEME_ORANGE ? SR_BADGE_THEME_GREY : theme;
};

const SrBulkBillingStatusBadge = ({ state, label, warning }) => (
  <SrBadge
    theme={bulkBillingBadgeTheme(state, warning)}
    icon={STATE_TO_ICON_MAPPING[state] || <CircleMinusIcon />}
  >
    {label}
  </SrBadge>
);

SrBulkBillingStatusBadge.propTypes = {
  state: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  warning: PropTypes.bool.isRequired,
};

SrBulkBillingStatusBadge.displayName = 'SrBulkBillingStatusBadge';

export default SrBulkBillingStatusBadge;
